export const HOSPITAL_HEARTCENTER_SECOND_OPINION_NUMBER = 18443542160;
export const HOSPITAL_HEARTCENTER_SECOND_OPINION_NUMBER_LOCAL = 16179196185;

// banner messages
export const CREATE_ACCOUNT_SUCCESS = 'An account is created for you successfully.';

export const CREATE_ACCOUNT_ERROR =
  'An error has occurred while creating an account. Please try again or contact us. ';

export const CREATE_CASE_SUCCESS =
  'Your case is created for you successfully. Please continue to fill in request detail information.';

export const CREATE_CASE_ERROR = 'An error has occurred while creating a case. Please try again.';

export const UPDATE_CASE_SUCCESS = 'Your second opinion case has successfully been updated.';

export const UPDATE_CASE_ERROR = 'An error has occurred while updating a case. Please try again.';

export const UPDATE_FIRSTNAME_SUCCESS = 'Your first name has successfully been updated.';

export const UPDATE_FIRSTNAME_ERROR =
  'An error has occurred while updating your first name. Please try again.';

export const UPDATE_LASTNAME_SUCCESS = 'Your last name has successfully been updated.';

export const UPDATE_LASTNAME_ERROR =
  'An error has occurred while updating your last name. Please try again.';

export const UPDATE_PHONE_SUCCESS = 'Your phone has successfully been updated.';

export const UPDATE_PHONE_ERROR =
  'An error has occurred while updating your phone. Please try again.';

export const UPDATE_PASSWORD_SUCCESS = 'Your password has successfully been updated.';

export const LOGIN_SUCCESS = 'Login successful';

export const LOGIN_ERROR = 'Login failed. Please try again.';

export const RESEND_CODE_ERROR = 'Resend verification code failed. ';

export const RESET_PASSWORD_SUCCESS = 'Reset password successful.';

export const RESET_PASSWORD_ERROR = 'Reset password failed. Please try again later. ';

// enum for caseStatus
// 1: New Inquiries (Unassigned)
// 10: New Inquiries (Assigned)
// 17: Waiting for records/family response
// 11: Under review by MD
// 12: Pending family approval
// 13: Finance review
// 14: Scheduling
// 15: Pending arrival
// 16: Arrived
// 9: Closed
export const STATUS_UNKNOWN = 0;
export const STATUS_NEW_UNASSIGNED = 1;
export const STATUS_NEW_ASSIGNED = 10;
export const STATUS_WAIT_FOR_RECORDS = 17;
export const STATUS_UNDER_REVIEW_BY_MD = 11;
export const STATUS_PENDING_FAMILY_APPROVAL = 12;
export const STATUS_FINANCE_REVIEW = 13;
export const STATUS_SCHEDULING = 14;
export const STATUS_PENDING_ARRIVAL = 15;
export const STATUS_ARRIVED = 16;
export const STATUS_CLOSED = 9;

export const UESR_IDLE_TIME_MAX = 900000;
